'use es6';

import { MARKETING } from 'self-service-api/constants/ProductLines';
import { TRAINING_AGENCY_MARKETING_HUB_FUNDAMENTALS } from 'self-service-api/constants/ProductNames';
import { productLevelInConfigsSelector } from '../selectors/ProductConfigsSelectors';
export const AdditionalServicesRestrictionMap = {
  [TRAINING_AGENCY_MARKETING_HUB_FUNDAMENTALS]: {
    isRestricted: (state, {
      productConfigurations
    }) => !productLevelInConfigsSelector(state, {
      productConfigurations,
      productLine: MARKETING
    })
  }
};